// Slice 40 — surface with optional title bar + icon + right-aligned actions.

import type { CSSProperties, ReactNode } from "react";
import type { IconComponent } from "./HqButton";

export interface HqCardProps {
  title?: ReactNode;
  icon?: IconComponent;
  right?: ReactNode;
  padding?: boolean;
  accent?: boolean;
  headerSubtle?: boolean;
  style?: CSSProperties;
  children?: ReactNode;
}

export function HqCard({
  title,
  icon: I,
  right,
  padding = true,
  accent = true,
  headerSubtle,
  style,
  children,
}: HqCardProps) {
  return (
    <div
      style={{
        borderRadius: "var(--hq-radius-2xl)",
        background: "var(--hq-bg-raised)",
        border: "1px solid var(--hq-border)",
        overflow: "hidden",
        ...style,
      }}
    >
      {(title || right) && (
        <div
          style={{
            height: 44,
            padding: "0 16px",
            display: "flex",
            alignItems: "center",
            gap: 8,
            borderBottom: "1px solid var(--hq-border)",
            background: headerSubtle ? "var(--hq-bg)" : "transparent",
          }}
        >
          {I && (
            <I
              width={14}
              height={14}
              sw={1.7}
              style={{ color: accent ? "var(--hq-accent)" : "var(--hq-text-dim)" }}
            />
          )}
          <span style={{ fontSize: 12.5, fontWeight: 500, color: "var(--hq-text)" }}>{title}</span>
          {right && (
            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 6 }}>
              {right}
            </div>
          )}
        </div>
      )}
      <div style={padding ? { padding: 16 } : undefined}>{children}</div>
    </div>
  );
}
